import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import type { MetaPixel } from './types/pixel';
const META_PIXEL_ID = '1367632915547845';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-base text-ink selection:bg-brand/20 selection:text-brand-dark" data-id="element-0" data-mp="36hx792iaw2a">
      <main data-id="element-1" data-mp="3ud1glcmeruc7">
        <Hero data-id="element-2" data-mp="3udaxmaph6r5r" />
        <TestimonialsStrip data-id="element-3" data-mp="3ubrgyizwqe3g" />
        <PainPoints data-id="element-4" data-mp="3ucjdpx58qhvb" />
        <SolutionReveal data-id="element-5" data-mp="3uf5g7id9y76o" />
        <VolumesSection data-id="element-6" data-mp="d57f31uekgij" />
        <BonusSection data-id="element-7" data-mp="d3cujon1mqez" />
        <PricingSection data-id="element-8" data-mp="d3wax0x1p6qw" />
        <ExtendedTestimonials data-id="element-9" data-mp="85l30vqb96bb" />
        <Guarantee data-id="element-10" data-mp="85bcn71csx53" />
        <FAQ data-id="element-11" data-mp="86w3omoglxy7" />
        <FinalCTA data-id="element-12" data-mp="86cm572q1bkp" />
      </main>
      <Footer data-id="element-13" data-mp="3gle9siuub3f6" />
      {showPurchaseNotifications && <PurchaseNotifications data-id="element-14" data-mp="3gm665vw9h56i" />}
    </div>;
}